import { render, staticRenderFns } from "./DomainServer.vue?vue&type=template&id=178e89de&"
import script from "./DomainServer.vue?vue&type=script&lang=js&"
export * from "./DomainServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports